import { EnvironmentId, ProjectId, ThreadId, } from "@t3tools/contracts";
export function scopeProjectRef(environmentId, projectId) {
    return { environmentId, projectId };
}
export function scopeThreadRef(environmentId, threadId) {
    return { environmentId, threadId };
}
export function scopedRefKey(ref) {
    const localId = "projectId" in ref ? ref.projectId : ref.threadId;
    return `${ref.environmentId}:${localId}`;
}
export function scopedProjectKey(ref) {
    return scopedRefKey(ref);
}
export function scopedThreadKey(ref) {
    return scopedRefKey(ref);
}
function parseScopedKey(key) {
    const separatorIndex = key.indexOf(":");
    if (separatorIndex <= 0 || separatorIndex >= key.length - 1) {
        return null;
    }
    return {
        environmentId: EnvironmentId.make(key.slice(0, separatorIndex)),
        localId: key.slice(separatorIndex + 1),
    };
}
export function parseScopedProjectKey(key) {
    const parsed = parseScopedKey(key);
    if (!parsed) {
        return null;
    }
    return {
        environmentId: parsed.environmentId,
        projectId: ProjectId.make(parsed.localId),
    };
}
export function parseScopedThreadKey(key) {
    const parsed = parseScopedKey(key);
    if (!parsed) {
        return null;
    }
    return {
        environmentId: parsed.environmentId,
        threadId: ThreadId.make(parsed.localId),
    };
}
